Object.defineProperty(exports,"__esModule",{value:true});var NativeModules={};exports.default=NativeModules;


// WEBPACK FOOTER //
// ./node_modules/react-native-web/dist/modules/NativeModules/index.js